import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { useMenu } from '@entities/Menu'

import SwitchLocale from '@features/switch-locale/ui'

import { CategoriesBranch } from '@widgets/categories-branch'
import { SocialList } from '@widgets/social-list'


import { CONTACTS } from '@shared/contants'
import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'

export default function MobileMenu () {
  const [ showCategories, setShowCateogories ] = useState<boolean>(false)
  const { t: tc } = useTranslation('common')
  const { t: tn } = useTranslation('navigation')
  const { menu } = useMenu({ code: 'header-top' })

  return (
    <div className={styles.menu}>
      {showCategories && (
        <div className={styles.categories}>
          <div className={styles.categories__top}>
            <Button
              theme="grey"
              size="small"
              onClick={() => setShowCateogories(false)}
            >
              <img
                className={styles['categories__arrow']}
                src="/icons/arrow.svg"
              />
              {tn('back')}
            </Button>
          </div>

          <CategoriesBranch />
        </div>
      )}

      {!showCategories && (
        <>
          <div className={styles.menu__list}>
            <button
              type="button"
              className={cn(
                'reset-button',
                styles.menu__item,
                styles.menu__catalog,
              )}
              onClick={() => setShowCateogories(true)}
            >
              <img src="/icons/grid-black.svg" />

              {tn('catalog')}

              <img
                className={styles['menu__catalog-arrow']}
                src="/icons/arrow.svg"
              />
            </button>

            {menu?.menuItems?.map((item) => {
              return (
                <Link to={item.link_url || '#'} className={styles.menu__item} key={item.id}>
                  {item.title}
                </Link>
              )
            })}
          </div>

          <div className={styles.menu__bottom}>
            <div>
              <SwitchLocale
                isMenu={true}
                className={styles['menu__switch-locale']}
              />
            </div>
            <div className={styles.menu__contacts}>
              <h3 className={styles.menu__title}>{tc('contacts.title')}</h3>

              { CONTACTS.phone && (
                <div>
                  <a className={styles.menu__phone} href={`tel:${CONTACTS.phone}`}>
                    {CONTACTS.phone}
                  </a>
                </div>
              )}

              <h3 className={styles.menu__title}>{tc('contacts.support')}</h3>

              { CONTACTS.email && (
                <div>
                  <a
                    className={styles.menu__email}
                    href={'mailto:' + CONTACTS.email}
                  >
                    {CONTACTS.email}
                  </a>
                </div>
              )}
            </div>

            <div className={styles.menu__social}>
              <h3 className={cn(styles.menu__title)}>{tc('social.title')}</h3>
              <SocialList />
            </div>
          </div>
        </>
      )}
    </div>
  )
}
